import { Component } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  standalone: true,
  templateUrl: "./maintenance.html",
  styleUrl: "./maintenance.scss",
  imports: [TranslateModule],
})
export class MaintenanceComponent {}
